/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_VideoInputs */

const vi_media_video = /** @type {(inputs: Media_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**

* @param {Media_VideoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_video = /** @type {((inputs?: Media_VideoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_VideoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_video(inputs)
});